var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-row',[_c('base-col',[_c('base-row',{attrs:{"no-gutters":""}},[_c('base-col',[_c('text-copy-button',{attrs:{"text":_vm.item.url,"outlined":"","color":"primary","label":"この項目のURLをコピー","complete-message":"コピーしました"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }